import React from "react";
import Chart from "react-apexcharts";

const HealthChart = () => {
    const options = {
        chart: {
            type: "radialBar",
        },
        plotOptions: {
            radialBar: {
                hollow: { size: "55%" },
                track: { background: "#333" },
                dataLabels: {
                    name: { show: false },
                    value: { show: false },
                },
            },
        },
        colors: ["#84BE71"],
    };

    const series = [85];

    return (
        <div className="flex items-center justify-center">
            <div className="relative">
                <Chart options={options} series={series} type="radialBar" width={250} height={300} />
                <p className="absolute top-3 right-3 font-bold text-white text-3xl">{series[0]}%</p>
                <img src="/assets/others/DNA.svg" className="absolute top-[40%] -translate-y-[50%] left-[50%] -translate-x-[50%] w-52"></img>
            </div>
            <p className="font-semibold capitalize text-white text-2xl ">Health <p className="text-base font-normal">score today</p></p>
        </div>
    );
};

export default HealthChart;
